/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  listenKeyBord.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2022/1/19 11:26
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

/**
 * listenKeyBord 监听移动端键盘弹起和收起事件
 * @param $input DOM元素（INPUT或者TEXTAREA）
 */
export function listenKeyBord ($input) {
    // 内部滚动容器页（如新建接龙）：由页面自行处理，禁止 window scrollIntoView 把整页顶起
    if ($input && typeof $input.closest === 'function' && $input.closest('[data-keyboard-inner-scroll]')) {
        return
    }

    if (window.platform === '2') {
        const version = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/)
        // IOS 键盘收起：IOS 点击输入框以外区域或点击收起按钮，输入框都会失去焦点，键盘会收起，
        $input.addEventListener('blur', () => {
            // IOS 键盘收起后操作
            // 微信浏览器版本6.7.4+IOS12会出现键盘收起后，视图被顶上去了没有下来，页面上有多个输入框时
            const wechatInfo = window.navigator.userAgent.match(/MicroMessenger\/([\d\\.]+)/i)
            if (!wechatInfo) return

            const wechatVersion = wechatInfo[1]

            // @ts-ignore
            if (wechatVersion.replace(/\./g, '') >= 674 && +version[1] >= 12) {
                setTimeout(() => {
                    console.log(document.activeElement)
                    if (document.activeElement.tagName !== 'INPUT' && document.activeElement.tagName !== 'TEXTAREA') {
                        window.scrollTo(0, Math.max(document.body.clientHeight, document.documentElement.clientHeight))
                    }
                })
            }
        })

        $input.addEventListener('focus', () => {
            // ios 12版本录入框被软键盘遮挡的问题
            if (parseInt(version[1]) <= 12) {
                setTimeout(() => {
                    // document.body.scrollTop = document.body.scrollHeight
                    $input.scrollIntoView(true)
                }, 300)
            }
        })
    }

    // Andriod 键盘收起：Andriod 键盘弹起或收起页面高度会发生变化，以此为依据获知键盘收起
    if (window.platform === '1') {
        let originHeight = document.documentElement.clientHeight || document.body.clientHeight

        window.addEventListener('resize', () => {
            const resizeHeight = document.documentElement.clientHeight || document.body.clientHeight
            if (originHeight >= resizeHeight) {
                activeElementScrollIntoView($input, 500)
            }
            /* if (originHeight < resizeHeight) {
              console.log('Android 键盘收起啦！')
              // Android 键盘收起后操作
            } else {
              console.log('Android 键盘弹起啦！')
              // Android 键盘弹起后操作
              this.activeElementScrollIntoView($input, 500)
            } */
            originHeight = resizeHeight
        }, false)
    }
}

/**
 * activeElementScrollIntoView 安卓机获取到焦点元素滚动到可视区
 * @param activeElement DOM元素（INPUT或者TEXTAREA）
 * @param delay 延迟时间
 */
export function activeElementScrollIntoView (activeElement, delay) {
    const editable = activeElement.getAttribute('contenteditable')
    // 输入框、textarea或富文本获取焦点后没有将该元素滚动到可视区
    if (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA' || editable === '' || editable) {
        setTimeout(() => {
            activeElement.scrollIntoViewIfNeeded(true)
            activeElement.scrollIntoView(true)
        }, delay)
    }
}
